import { supabase } from "@/lib/supabase";
import { USE_SUPABASE } from "@/lib/dataSource";
import { QuartierSchema, type QuartierRow, type QuartierUpdate } from "@/schemas/quartier";
import { MOCK_QUARTIERS } from "@/data/mock";
import { z } from "zod";

function fromMocks(): QuartierRow[] {
  return MOCK_QUARTIERS as unknown as QuartierRow[];
}

async function listFromSupabase(role: string): Promise<QuartierRow[]> {
  const { data, error } = await supabase.rpc("get_quartiers_for_role", { p_role: role });
  if (error) throw new Error(`listQuartiers: ${error.message}`);
  return z.array(QuartierSchema).parse(data ?? []);
}

async function updateOnSupabase(role: string, id: string, patch: QuartierUpdate): Promise<QuartierRow> {
  const { data, error } = await supabase.rpc("update_entity_with_perms", {
    p_table_name: "quartiers",
    p_role: role,
    p_id: id,
    p_data: patch,
  });
  if (error) throw new Error(`updateQuartier(${id}): ${error.message}`);
  return QuartierSchema.parse(data);
}

export const quartiersRepository = {
  async list(role: string): Promise<QuartierRow[]> {
    if (!USE_SUPABASE) return fromMocks();
    return listFromSupabase(role);
  },

  async get(role: string, id: string): Promise<QuartierRow | null> {
    if (!USE_SUPABASE) {
      return fromMocks().find((q) => q.id === id) ?? null;
    }
    const all = await listFromSupabase(role);
    return all.find((q) => q.id === id) ?? null;
  },

  async update(role: string, id: string, patch: QuartierUpdate): Promise<QuartierRow> {
    if (!USE_SUPABASE) {
      const q = fromMocks().find((x) => x.id === id);
      if (!q) throw new Error(`Quartier introuvable: ${id}`);
      return { ...q, ...patch };
    }
    return updateOnSupabase(role, id, patch);
  },
};
